import Select from 'src/components/Inputs/Select/Select';
import { ToggleSwitch } from 'src/components/Inputs';
import { useContext } from 'react';
import DocsContext from 'src/contexts/docs';
import styles from './index.module.scss';
import LoggedInWrapper from '../LoggedInWrapper';
import { useRouter } from 'next/router';
import {
  CLIENT_LANGUAGE_OPTIONS,
  SERVER_LANGUAGE_MAPPING,
  SERVER_LANGUAGE_OPTIONS,
} from '../constants';
import useUser from 'src/contexts/docs/useUser';
import cx from 'classnames';

const DocsSettingsLoggedOut = () => {
  const { isLoggedIn } = useContext(DocsContext);
  if (isLoggedIn !== null) {
    const router = useRouter();
    if (router) {
      router.push('/docs');
    }
  }
  return <></>;
};

const DocsSettingsLoggedIn = () => {
  const { user, serverCodeLanguage, clientLanguage, dispatch } =
    useContext(DocsContext);

  const { patchPreferences } = useUser();

  const currentServerOption = SERVER_LANGUAGE_OPTIONS.find(
    (option) => SERVER_LANGUAGE_MAPPING[option.value] === serverCodeLanguage,
  );

  const currentClientOption = CLIENT_LANGUAGE_OPTIONS.find(
    (option) => option.value === clientLanguage,
  );

  const toggleAPIKey = () => {
    dispatch({ type: 'TOGGLE_API_KEY' });
    patchPreferences({ showAPIKeys: !user.showAPIKeys });
  };

  return (
    <div className={styles.docsSettings}>
      <h1>Plaid Docs Settings</h1>
      <p>Adjust your Plaid documentation preferences</p>

      <div className={cx(styles.section, styles.bottomBorder)}>
        <h4 className={styles.header}>Programming Languages</h4>
        <p>
          Select a <b>server side</b> default programming language{' '}
        </p>
        <Select
          label='Language'
          name='Language'
          defaultValue={currentServerOption}
          id='language-select-server'
          onChange={(option) =>
            patchPreferences({ codingLanguageBackend: option.value })
          }
          options={SERVER_LANGUAGE_OPTIONS}
          value={currentServerOption as any}
        />

        <p>
          Select a <b>client side</b> default programming language
        </p>

        <Select
          label='Language'
          name='Language'
          defaultValue={currentClientOption}
          id='language-select-client'
          onChange={(option) =>
            patchPreferences({ codingLanguageFrontend: option.value })
          }
          value={currentClientOption as any}
          options={CLIENT_LANGUAGE_OPTIONS}
        />
      </div>
      <div className={styles.section}>
        <h4 className={styles.header}>API Keys</h4>
        <p>
          Display preference for Sandbox client_id and secret in code samples.
          [Sandbox API]
        </p>

        <ToggleSwitch
          id='apiKeyToggle'
          value={user.showAPIKeys}
          trueText='Show Client_ID & Secret'
          falseText='Show Client_ID & Secret'
          onChange={toggleAPIKey}
        >
          {' '}
        </ToggleSwitch>
      </div>
    </div>
  );
};

const DocsSettings = () => {
  return (
    <LoggedInWrapper
      loggedInComponent={<DocsSettingsLoggedIn />}
      loggedOutComponent={<DocsSettingsLoggedOut />}
    />
  );
};

export default DocsSettings;
